// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pwz8I","smallImg":"styles_smallImg__D-vJI","bigImg":"styles_bigImg__kGgLn"};